export const CARD_PROPORTIONS_HEIGHT = {
    '1:1': 1,
    '5:4': 0.8,
    '4:5': 1.2,
}
